const keys = {

    WEB_BASE_URL: 'http://localhost:5000/', 
    
    API_UPDATE_USER: 'api/trans/updateuser/',
    API_DELETE_USER: 'api/trans/deleteuser/',
    API_ADD_USER:'api/trans/adduser',
    API_LOGIN: 'api/trans/login'

}

export default keys; 